import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";

let redux = reduxCreator.type('USERS').plugin(axiosPlugin, {template: "array"});

let fetchUsersAction = redux.fetchActionGet();

export const fetchUsers = (query) => {
    // if(query.sortBy){
    //     let sort = ['username', '-count.comment', '-createdAt', 'createdAt', 'online'];
    //     query = {...query, sort: sort[query.sortBy] || 0};
    //     delete query.sortBy;
    // }

    return fetchUsersAction(`/users?${queryString.stringify(query)}`)
};
export const fetchTopUsers = (query = {}) => {
    let sort = ['username', '-count.comment', '-createdAt'];
    query = {...query, sort: sort[query.sort] || 0};
    return fetchUsersAction(`/users?${queryString.stringify(query)}`)
};
export const resetUsers = () => redux.actions.reset();

export const users = redux.reducer();